import { GridColDef } from '@mui/x-data-grid';

export const getLogisticsOrderDetailsItemsColumns = (): GridColDef[] => {
  return [
    {
      field: 'sku',
      headerName: 'SKU',
    },
    {
      field: 'name',
      headerName: 'Item',
    },
    {
      field: 'quantity',
      headerName: 'Qty',
    },
    {
      field: 'price',
      headerName: 'Price',
    },
    {
      field: 'total',
      headerName: 'Total',
    },
  ];
};
